import { AppEnv } from '@brightdrop/app-config';

/** Per-environment binary cap for feedback screenshots (aligned with API limits). */
const FEEDBACK_IMAGE_MAX_BYTES_BY_ENV: Record<AppEnv, number> = {
  [AppEnv.DEV]: 128 * 1024,
  [AppEnv.QA]: 128 * 1024,
  [AppEnv.UAT]: 850 * 1024,
  [AppEnv.PROD]: 1024 * 1024,
};

export function getMaxFeedbackImageBytes(): number {
  const env = globalThis.appConfig?.env;
  if (env != null && Object.hasOwn(FEEDBACK_IMAGE_MAX_BYTES_BY_ENV, env)) {
    return FEEDBACK_IMAGE_MAX_BYTES_BY_ENV[env];
  }
  return FEEDBACK_IMAGE_MAX_BYTES_BY_ENV[AppEnv.DEV];
}

/** `react-drag-drop-files` `maxSize` is expressed in megabytes. */
export function getMaxFeedbackImageSizeMbForUploader(): number {
  return getMaxFeedbackImageBytes() / (1024 * 1024);
}

/** Short label for UI copy (e.g. "128KB", "850KB", "1MB"). */
export function formatFeedbackImageMaxSizeLabel(bytes: number): string {
  const wholeMb = bytes / (1024 * 1024);
  if (Number.isInteger(wholeMb)) {
    return `${wholeMb}MB`;
  }
  const wholeKb = bytes / 1024;
  if (Number.isInteger(wholeKb)) {
    return `${wholeKb}KB`;
  }
  return `${Math.round(wholeKb)}KB`;
}
